import Vue from "vue"
import VueI18n, { LocaleMessages } from "vue-i18n"
import VueMoment from "vue-moment"
import moment from "moment-timezone"

import ja from "js-yaml-loader!@/locales/ja.yaml"
import en from "js-yaml-loader!@/locales/en.yaml"

import "moment/locale/ja"

const supportedLocales = Object.freeze([
  { key: "ja", label: "日本語" },
  { key: "en", label: "English" },
])
export const defaultLocale = "ja"
moment.locale(defaultLocale)

Vue.use(VueI18n)
Vue.use(VueMoment, { moment })

export default new VueI18n({
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  messages: { ja, en },
})

export const getAvailableLocales = () => supportedLocales
export const momentInstance = moment
